const stripDisallowedIdCharacters = (value: string): string => {
  // Convert all characters to lower case
  const lowerCaseValue = value.toLowerCase();

  // Define a regular expression to match disallowed characters
  const disallowedRegex = /[^a-z0-9_]/g;

  // Replace disallowed characters with underscores
  const res = lowerCaseValue.replace(disallowedRegex, '_');

  return res;
};

export default stripDisallowedIdCharacters;
